import React from 'react'
import { TabsList as BaseTabsList, TabsListProps } from '@mui/base/TabsList'
import classes from './TabsList.module.scss'

export const TabsList = ({ children, ...props }: TabsListProps) => {
  return (
    <BaseTabsList className={classes.root} {...props}>
      {children}
    </BaseTabsList>
  )
}
